import { DialogActions } from '../primitives/dialog.js'
import { Button } from '../primitives/button.js'
import type { DefaultValues } from '../autoform/index.js'
import { AutoForm } from '../autoform/index.js'
import type { $ZodType } from 'zod/v4/core'
import { useCallback, useState } from 'react'
import type { CDialogProps } from './dialog.js'
import { Dialog } from './dialog.js'

interface FormDialogProps<T> {
  dialogProps: Omit<CDialogProps, 'onClose' | 'open'>
  open: boolean
  schema: $ZodType<T>
  defaultValues?: DefaultValues<T>
  onChange(value: T): void
  onClose(success: boolean): void
}

export const FormDialog = <T extends Record<string, unknown> = Record<string, unknown>>({
  open,
  schema,
  dialogProps,
  defaultValues,
  onChange,
  onClose,
}: FormDialogProps<T>) => {
  const [valid, setValid] = useState(Boolean(defaultValues))
  const handleChange = useCallback(
    (val: T) => {
      setValid(true)
      onChange(val)
    },
    [onChange]
  )
  const handleClose = useCallback(
    (success: boolean) => () => {
      onClose(success)
    },
    [onClose]
  )

  const handleError = useCallback(() => {
    setValid(false)
  }, [])
  return (
    <Dialog open={open} onClose={handleClose(false)} showClose={false} showOK={false} {...dialogProps}>
      <AutoForm defaultValues={defaultValues} schema={schema} onSubmit={handleChange} onError={handleError} />

      <DialogActions>
        <Button disabled={!valid} onClick={handleClose(true)}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
